import classnames from 'classnames/bind'
import { useRouter } from 'next/router'

// Methods
import handleRoutePushWithQuery from '@/methods/url/handleRoutePushWithQuery'

// Components
import Image from '@/components/common/Image'
import DiscountRateTag from '@/components/shared/DiscountRateTag'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'

import styles from './style.module.scss'

const cx = classnames.bind(styles)

type Product = {
  id: string
  name: string
  imageUrl: string
  originalPrice: number
  minOrigPrice: number
  minPrice: number
  minLivePrice: number
  discount?: string
}

type DealProductCardProps = {
  product: Product
}

const SaleProductCard = ({ product }: DealProductCardProps) => {
  const router = useRouter()

  const handleProductClick = () => {
    handleRoutePushWithQuery({ router, pathname: `${ROUTE_PATH.PRODUCT}/${product.id}` })
  }

  const minDisplayPrice = product.minLivePrice || product.minPrice || product.minOrigPrice

  const isShowMinPrice = minDisplayPrice < product.originalPrice

  return (
    <div className={cx('sub-card')} onClick={handleProductClick}>
      <div className={cx('sub-card__image-wrapper')}>
        <Image src={product.imageUrl} alt={product.name} fill style={{ objectFit: 'contain' }} />
      </div>
      <div className={cx('sub-card__info')}>
        <h4 className={cx('sub-card__name')}>{product.name}</h4>
        {isShowMinPrice && <span className={cx('sub-card__original-price')}>${product.originalPrice.toLocaleString()}</span>}
        <div className={cx('sub-card__sale-price-container')}>
          <span className={cx('sub-card__sale-price')}>${minDisplayPrice.toLocaleString()}</span>
          <DiscountRateTag productPrice={minDisplayPrice} productOriginalPrice={product.originalPrice} gapPosition='right' />
        </div>
      </div>
    </div>
  )
}

export default SaleProductCard
